import * as FS from "@fullstory/browser"

export function configFullstory({
  userId,
  email,
}: {
  userId: string
  email: string
}) {
  if (
    typeof window !== "undefined" &&
    !!process.env.NEXT_PUBLIC_FULLSTORY_ORG_ID &&
    process.env.NODE_ENV !== "development"
  ) {
    FS.init({ orgId: process.env.NEXT_PUBLIC_FULLSTORY_ORG_ID })
    FS.identify(userId, { email })
  }
}
